exports.polyfill = Component => Component;